export const IMG = {
  logo: require('../images/logo.png')
};
